import { render, staticRenderFns } from "./ServiceCenter.vue?vue&type=template&id=3b022b62&scoped=true"
import script from "./ServiceCenter.vue?vue&type=script&lang=js"
export * from "./ServiceCenter.vue?vue&type=script&lang=js"
import style0 from "./ServiceCenter.vue?vue&type=style&index=0&id=3b022b62&prod&lang=scss&scoped=true"
import style1 from "./ServiceCenter.vue?vue&type=style&index=1&id=3b022b62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b022b62",
  null
  
)

export default component.exports